import { AppBreadcrumb, AppContainer } from '@/components/atoms';
import { AdminInsurerAttentionEditForm } from '@/components/organisms';
import { LoadingTemplate, SiteAdminNotFoundTemplate } from '@/components/templates';
import {
  useAdminInsurerAttentionBulkDelete,
  useAdminInsurerAttentionDetail,
  useAdminInsurerAttentionInit,
  useAdminInsurerAttentionUpdate,
} from '@/hooks/admin';
import { useStandardDeleteConfirm } from '@/hooks/useStandardDeleteConfirm';
import { AdminInsurerAttentionUpdateForm } from '@/types/admin-insurer-attention';
import { useNavigate, useParams } from 'react-router-dom';

const SiteAdminInsurerAttentionEditPage = () => {
  const { site, id } = useParams<{ site: string; id: string }>();
  const currentSite = site ?? 'medix';
  const navigate = useNavigate();

  const listPath = `/${currentSite}/admin/insurer_attentions`;

  const { data: record, isLoading } = useAdminInsurerAttentionDetail(id!);
  const { data: initData, isLoading: isInitLoading } = useAdminInsurerAttentionInit();
  const { mutateAsync: updateRecord, isPending } = useAdminInsurerAttentionUpdate();
  const { mutate: bulkDelete, isPending: isDeleting } = useAdminInsurerAttentionBulkDelete(() =>
    navigate(listPath)
  );

  const openDeleteConfirm = useStandardDeleteConfirm();

  if (isLoading || isInitLoading) return <LoadingTemplate />;
  if (!record) return <SiteAdminNotFoundTemplate />;

  const prefectureOptions = initData?.prefectures?.map(p => ({ value: p.id, label: p.name })) ?? [];

  const breadcrumbItems = [{ title: '県別注意事項', href: listPath }, { title: ':id' }];

  const handleSubmit = async (data: AdminInsurerAttentionUpdateForm) => {
    await updateRecord({ id: id!, data });
    navigate(listPath);
  };

  const handleDelete = () => {
    openDeleteConfirm({
      onOk: () => bulkDelete([Number(id)]),
      okButtonProps: { loading: isDeleting },
    });
  };

  const handleReflect = () => {
    navigate(listPath, { state: { reflectRecord: record } });
  };

  return (
    <AppContainer className="py-6">
      <div className="mb-6">
        <AppBreadcrumb items={breadcrumbItems} paramsLabel="編集" />
      </div>
      <AdminInsurerAttentionEditForm
        record={record}
        prefectureOptions={prefectureOptions}
        isPending={isPending}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        onReflect={handleReflect}
        onBack={() => navigate(-1)}
      />
    </AppContainer>
  );
};

export default SiteAdminInsurerAttentionEditPage;
